<template>
  <div>
    <span class="text-info font-weight-bold">
      Downloading {{ downloadedCount }}/{{ downloadFileCount }} files...
    </span>
    <CProgress class="mt-1">
      <CProgressBar
        color="info"
        :value="downloadProgress"
        animated
      />
    </CProgress>
  </div>
</template>

<script>
export default {
  name: 'DownloadProgress',

  props: {
    downloadedCount: {
      type: Number,
      required: true
    },
    downloadFileCount: {
      type: Number,
      required: true
    },
    downloadProgress: {
      type: Number,
      required: true
    }
  }
}
</script>
